import type {ReportPageContent, ReportRunSet} from '../../store/thread';
import {type AgentPageContextReader} from '../channel';
import {runCountFiltered, runCountTotal, runsFilter} from './workspace';

/**
 * reportReducer assembles a report's run sets, one per group, dropping run sets
 * that carry no data.
 */
export const reportReducer = (
  read: AgentPageContextReader
): Omit<ReportPageContent, 'type'> | null => {
  const runSets: ReportRunSet[] = read
    .groups()
    .map(group => ({
      runCountTotal: group.one(runCountTotal),
      runCountFiltered: group.one(runCountFiltered),
      runFiltersExpression: group.one(runsFilter),
    }))
    .filter(runSet => Object.values(runSet).some(value => value !== undefined));
  return runSets.length > 0 ? {runSets} : null;
};
